<template>
  <div class="bg-white p-y-15 p-x-24 border-radius-12 full-height">
    <tk-flex middle between>
      <div class="font-14 flex-s-0" >积分商城</div>
      <tk-flex wrap :gutter="10">
        <!--  :defaultValue="getDefaultDate()" -->
        <a-week-picker
          :defaultValue="_defaultDate"
          @change="(date, dateString) => onChange(date, dateString)"
          style="maxWidth: 110px;"
        />
      </tk-flex>
    </tk-flex>
    <div class="font-14 m-t-12">本月订单量:<span class="font-16 font-bold">{{ pointsOrderSum }}</span></div>
    <div ref="pointsMall" style="width: 100%;height: 450px;"></div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'
import { getDayAll, formatDate } from '@/assets/js/utils.js'
export default {
  data () {
    return {
      pointsOrderSum: 0,
      optionNum: {
        color: ['#F6313F'],
        tooltip: {
          trigger: 'axis',
          axisPointer: { // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: {
          top: '40px',
          left: '54px',
          right: '24px',
          bottom: '40px'
        },
        xAxis: [
          {
            type: 'category',
            data: [],
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: {
          type: 'value',
          axisLabel: {
            // eslint-disable-next-line no-template-curly-in-string
            formatter: '{value}'
          }
        },
        series: [
          { // For shadow
            // data: clueMaxArr,
            type: 'bar',
            zlevel: 1,
            barGap: '0%',
            barCategoryGap: '40%',
            itemStyle: {
              color: '#F6313F'
            },
            animation: false
          },
          {
            name: '订单量',
            type: 'bar',
            barWidth: '20px',
            data: []
          }
        ]
      }
    }
  },
  computed: {
    ...mapState(['user']),
    _defaultDate () {
      const startOfWeek = moment().startOf('isoWeek')
      const middleOfWeek = startOfWeek.clone().isoWeekday(4)
      console.log('Middle of week:', middleOfWeek.format('YYYY-MM-DD'))
      return moment(middleOfWeek.format('YYYY-MM-DD'))
    }
  },
  mounted () {
    this.initPointsChart()
    this.getGroupOrders(this.getDefaultDate()[0],
      this.getDefaultDate()[1], true)
  },
  methods: {
    initWhere () {
      let where = {}
      /// 对应部门下面的销售额
      if (this.user.adminRole === 'staff') {
        if (this.user.level === '1') where.warZone = this.user.department
        if (this.user.level === '2') where.regional = this.user.department
        if (this.user.level === '3') {
          where.agency = this.user.department
          where.agent = this.user.objectId
        }
        if (this.user.level === '4') {
          where.salesmancy = this.user.department
          where.salesman = this.user.objectId
        }
      }
      return where
    },
    onChange (date, dateString) {
      // 打印当前周的开始时间和结束时间
      const startDate = moment(date).day(1).format('YYYY-MM-DD')
      const endDate = moment(date).day(7).format('YYYY-MM-DD')
      if (!dateString) {
        this.initPointsChart()
        return
      }
      let iso = this.getDefaultDate(startDate, endDate)
      this.setOption(formatDate(iso[0]), formatDate(iso[1]), iso[0].toISOString(), iso[1].toISOString())
    },
    getDefaultDate (firs, last) {
      var date = new Date()
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 0, 0, 0, 0)
      var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0, 23, 59, 59, 999)
      if (firs) firstDay = new Date(new Date(firs).setHours(0, 0, 0, 0))
      if (last) lastDay = new Date(new Date(last).setHours(23, 59, 59, 999))
      return [firstDay, lastDay]
    },
    initPointsChart () {
      // 获取当前日期所属的周的开始时间和结束时间
      const startOfWeek = moment().startOf('isoWeek')
      const endOfWeek = moment().endOf('isoWeek')
      let iso = this.getDefaultDate(startOfWeek, endOfWeek)
      this.setOption(formatDate(iso[0]), formatDate(iso[1]), iso[0].toISOString(), iso[1].toISOString())
    },
    async getGroupOrders (firstDay, lastDay, isMonth) {
      let where = this.initWhere()
      let { data: res } = await this.$tkParse.get(`/aggregate/pointsOrder`, {
        params: {
          group: {
            objectId: isMonth ? '' : {
              day: { $dayOfMonth: '$createdAt' },
              month: { $month: '$createdAt' },
              year: { $year: '$createdAt' },
              type: '$createdAt'
            },
            total: {
              $sum: 1
            }
          },
          match: {
            // ...{ status: '2' },
            ...{
              createdAt: {
                $gt: firstDay,
                $lt: lastDay
              }
            },
            ...where
          } // 查询条件
        }
      })
      if (isMonth) this.pointsOrderSum = res.results && res.results.length ? res.results[0].total || 0 : 0
      return res.results
    },
    // 请求数据，并设置数据， 刷新图表
    async setOption (firstTime, lastTime, firstDay, lastDay) {
      let res = await this.getGroupOrders(firstDay, lastDay)
      let back = await this.dateline(firstTime, lastTime, res)
      // 日期赋值
      this.optionNum.xAxis[0].data = back[0]
      this.optionNum.series[1].data = back[1]
      // 渲染图表
      this.sellOrderLine()
    },
    // 订单量统计
    sellOrderLine () {
      let mychart = this.$echarts.init(this.$refs.pointsMall)
      mychart.setOption(this.optionNum)
      // 自动渲染echarts
      window.addEventListener('resize', () => {
        mychart.resize()
      })
    },
    async dateline (firstTime, lastTime, data) {
      var dataAll = getDayAll(firstTime, lastTime)

      var dataNull = dataAll[1]

      // 获取的数据，拼接时间，对比空数据索引，赋值
      for (let index = 0; index < data.length; index++) {
        const element = data[index]
        let time = element.objectId.year + '-' + (element.objectId.month >= 10 ? element.objectId.month : ('0' + element.objectId.month)) + '-' + (element.objectId.day >= 10 ? element.objectId.day : ('0' + element.objectId.day))
        let i = dataAll[0].indexOf(time)
        if (i !== -1) dataNull[i] = element.total
      }

      let newData = []
      for (let index = 0; index < dataAll[0].length; index++) {
        const element = dataAll[0][index]
        let str = element.split('-')
        newData.push(str[1] + '/' + str[2])
      }
      return [newData, dataNull]
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
